import { getDashBoardIcon } from '../../../util/widgetDashboard'
import { PredefinedDashboard } from '../widgetDashboard.enums'
import { PredefinedDashboardMenuType } from '../widgetDashboard.interface'
import { Layout_1 } from './dl_1'
import { Layout_h2 } from './dl_h2'
import { Layout_h2_1h2_2v2 } from './dl_h2_1h2_2v2'
import { Layout_h2_1v2 } from './dl_h2_1v2'
import { Layout_h2_1v2_2v2 } from './dl_h2_1v2_2v2'
import { Layout_h2_1v3 } from './dl_h2_1v3'
import { Layout_h2_2v2 } from './dl_h2_2v2'
import { Layout_h2_2v3 } from './dl_h2_2v3'
import { Layout_h3 } from './dl_h3'
import { Layout_h4 } from './dl_h4'
import { Layout_v2 } from './dl_v2'
import { Layout_v2_1h2 } from './dl_v2_1h2'
import { Layout_v2_1h2_2v2 } from './dl_v2_1h2_2v2'
import { Layout_v2_2h2 } from './dl_v2_2h2'
import { Layout_v2_2h3 } from './dl_v2_2h3'
import { Layout_v3 } from './dl_v3'
import { Layout_v4 } from './dl_v4'

export const predefinedDashboardMenu: PredefinedDashboardMenuType[][] = [
    [{
        id: PredefinedDashboard.LAYOUT_1,
        icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_1),
        wrapper: new Layout_1(),
        category: 1
    },
        {
            id: PredefinedDashboard.LAYOUT_H2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2),
            wrapper: new Layout_h2(),
            category: 2
        },
        {
            id: PredefinedDashboard.LAYOUT_V2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V2),
            wrapper: new Layout_v2(),
            category: 2
        }],
    [{
        id: PredefinedDashboard.LAYOUT_H3,
        icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H3),
        wrapper: new Layout_h3(),
        category: 3
    },
        {
            id: PredefinedDashboard.LAYOUT_V3,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V3),
            wrapper: new Layout_v3(),
            category: 3
        },
        {
            id: PredefinedDashboard.LAYOUT_H2_1V2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2_1V2),
            wrapper: new Layout_h2_1v2(),
            category: 3
        },
        {
            id: PredefinedDashboard.LAYOUT_H2_2V2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2_2V2),
            wrapper: new Layout_h2_2v2(),
            category: 3
        },
        {
            id: PredefinedDashboard.LAYOUT_V2_1H2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V2_1H2),
            wrapper: new Layout_v2_1h2(),
            category: 3
        },
        {
            id: PredefinedDashboard.LAYOUT_V2_2H2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V2_2H2),
            wrapper: new Layout_v2_2h2(),
            category: 3
        }],
    [{
        id: PredefinedDashboard.LAYOUT_H2_1V2_2V2,
        icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2_1V2_2V2),
        wrapper: new Layout_h2_1v2_2v2(),
        category: 4
    },
        {
            id: PredefinedDashboard.LAYOUT_H4,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H4),
            wrapper: new Layout_h4(),
            category: 4
        },
        {
            id: PredefinedDashboard.LAYOUT_V4,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V4),
            wrapper: new Layout_v4(),
            category: 4
        },
        {
            id: PredefinedDashboard.LAYOUT_H2_2V3,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2_2V3),
            wrapper: new Layout_h2_2v3(),
            category: 4
        },
        {
            id: PredefinedDashboard.LAYOUT_H2_1V3,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2_1V3),
            wrapper: new Layout_h2_1v3(),
            category: 4
        },
        {
            id: PredefinedDashboard.LAYOUT_V2_2H3,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V2_2H3),
            wrapper: new Layout_v2_2h3(),
            category: 4
        },
        {
            id: PredefinedDashboard.LAYOUT_V2_1H2_2V2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_V2_1H2_2V2),
            wrapper: new Layout_v2_1h2_2v2(),
            category: 4
        },
        {
            id: PredefinedDashboard.LAYOUT_H2_1H2_2V2,
            icon: getDashBoardIcon(PredefinedDashboard.LAYOUT_H2_1H2_2V2),
            wrapper: new Layout_h2_1h2_2v2(),
            category: 4
        }]
]

export default predefinedDashboardMenu


